import { gql } from "@apollo/client";

export interface LoginResponse {
  login: {
    accessToken: string;
    refreshToken: string;
    idToken: string;
    isValid: string;
    lastPass?: string;
  };
}

export interface OtpResponse {
  otp: {
    done: string;
    message: string;
  };
}

export interface OtpVars {
  userId: string | undefined;
  method: string | undefined;
}

export interface UpdatePhoneNumberResponse {
  uppdatePhoneNumber: {
    done: string;
  };
}

export interface UpdatePhoneNumberVars {
  userId: string | undefined;
  phoneNumber: string | undefined;
}

export interface VerifyOtpVars {
  userId: string | undefined;
  code: string;
}

export interface VerifyOtpResponse {
  verifyOtp: {
    done: string;
    message: string;
  };
}

export interface LoginVars {
  username: string;
  password: string;
}

export interface LogOutResponse {
  expireRefreshToken: {
    done: string;
  };
}

export interface LogOutVars {
  userId: string | undefined;
}

export const GET_LOGIN = gql`
  mutation getLogin($username: String!, $password: String!) {
    login(data: { username: $username, password: $password }) {
      accessToken
      refreshToken
      idToken
      isValid
      lastPass
    }
  }
`;

export const LOG_OUT = gql`
  mutation expireRefreshToken($userId: String!) {
    expireRefreshToken(data: { userId: $userId }) {
      done
    }
  }
`;

export const GET_OTP = gql`
  mutation getOtp($userId: String!, $method: String!) {
    getOtp(data: { userId: $userId, method: $method }) {
      done
      message
    }
  }
`;

export const VERIFY_OTP = gql`
  mutation verifyOtp($userId: String!, $code: String!) {
    verifyOtp(data: { userId: $userId, code: $code }) {
      done
      message
    }
  }
`;

export const UPDATE_PHONE_NUMBER = gql`
  mutation updatePhoneNumber($userId: String!, $phoneNumber: String!) {
    updatePhoneNumber(data: { userId: $userId, phoneNumber: $phoneNumber }) {
      done
    }
  }
`;
